import { createUseStyles } from 'react-jss'
import { style as imageBlockStyle } from '../../blocks/image/image-block.style'

export const style = {
  preview: {
    padding: 15
  },
  ...imageBlockStyle
}

export const useStyles = createUseStyles(style)
